import { UseFormReturn } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import STATES from '../../../../helpers/states';
import {
  AssessmentCard,
  ControlledMaskedField,
  ControlledSelectField,
  ControlledTextField,
} from '../../shared';
import { rules } from '../../demographics/rules';
import { selectMedicalInfoAnswers } from '../../../../redux/assessment';
import { MedicationPharmacyFormValues } from '../medication-pharmacy';

export type PharmacyFormValues = {
  hasPharmacy: 'Yes' | 'No' | null;
  name: string;
  addressStreet1: string;
  addressStreet2: string;
  addressCity: string;
  addressState: string;
  addressZipCode: string;
  phone: string;
};

type PropTypes = {
  form: UseFormReturn<MedicationPharmacyFormValues>;
};

export const PharmacyForm = ({ form: { control } }: PropTypes) => {
  const medicalInfoAnswers = useSelector(selectMedicalInfoAnswers);
  const pharmacy = medicalInfoAnswers.MI_PrimaryPharmacyDetails;

  const stateOptions = STATES.map(state => ({
    label: state.name,
    value: state.code,
  }));

  return (
    <AssessmentCard>
      <Typography component="h3" variant="h5">
        Which pharmacy do you use?
      </Typography>
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={12} sm={6}>
          <ControlledTextField<PharmacyFormValues>
            control={control}
            name="name"
            defaultValue={pharmacy?.name ?? ''}
            autoComplete="off"
            label="Pharmacy name"
            rules={rules.pharmacyName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledMaskedField<PharmacyFormValues>
            control={control}
            name="phone"
            defaultValue={pharmacy?.phone ?? ''}
            label="Phone"
            mask="(999) 999-9999"
            rules={rules.phone}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField<PharmacyFormValues>
            control={control}
            name="addressStreet1"
            defaultValue={pharmacy?.addressStreet1 ?? ''}
            autoComplete="off"
            label="Street address"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField<PharmacyFormValues>
            control={control}
            name="addressStreet2"
            defaultValue={pharmacy?.addressStreet2 ?? ''}
            autoComplete="off"
            label="Floor, suite, etc"
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField<PharmacyFormValues>
            control={control}
            name="addressCity"
            defaultValue={pharmacy?.addressCity ?? ''}
            autoComplete="off"
            label="City"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledSelectField<PharmacyFormValues>
            control={control}
            name="addressState"
            defaultValue={pharmacy?.addressState ?? ''}
            options={stateOptions}
            label="State"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField<PharmacyFormValues>
            control={control}
            name="addressZipCode"
            defaultValue={pharmacy?.addressZipCode ?? ''}
            autoComplete="off"
            inputMode="numeric"
            label="ZIP"
            rules={rules.addressZipCodeOptional}
          />
        </Grid>
      </Grid>
    </AssessmentCard>
  );
};
